import { addDoc, collection, doc, getFirestore, onSnapshot, serverTimestamp, updateDoc } from './instrumentedFirestore';
import { getFirebaseApp } from './app';
import { COLLECTIONS } from '@constants/firestorePaths';

function db() {
    return getFirestore(getFirebaseApp());
}

function stripUndefined(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    const next = {};
    for (const [k, v] of Object.entries(obj)) {
        if (typeof v === 'undefined') continue;
        next[k] = v;
    }
    return next;
}

export function subscribePlans(onNext, onError) {
    return onSnapshot(
        collection(db(), COLLECTIONS.PLANS),
        (snap) => {
            const rows = snap.docs
                .map((d) => ({ id: d.id, ...d.data() }))
                .sort((a, b) => {
                    const ta = a.createdAt?.toMillis?.() ?? a.createdAt ?? 0;
                    const tb = b.createdAt?.toMillis?.() ?? b.createdAt ?? 0;
                    return tb - ta;
                });
            onNext(rows);
        },
        onError
    );
}

export async function createPlan(payload, createdByUid) {
    const clean = stripUndefined(payload);
    const ref = await addDoc(collection(db(), COLLECTIONS.PLANS), {
        ...clean,
        modules: Array.isArray(clean.modules) ? clean.modules : [],
        createdByUid,
        createdAt: serverTimestamp(),
        active: clean.active ?? true,
    });
    return ref.id;
}

export async function updatePlan(planId, patch) {
    const clean = stripUndefined(patch);
    await updateDoc(doc(db(), COLLECTIONS.PLANS, planId), {
        ...clean,
        modules: Array.isArray(clean.modules) ? clean.modules : [],
        updatedAt: serverTimestamp(),
    });
    return planId;
}

